export default {"src":"/_next/static/media/bank_icon.141bd89f.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};